export default __webpack_public_path__ + "static/media/shape-hero-pelatihan.c0e1d9f0.webp";